import axios from "axios";
import { toast } from "react-toastify";

export const handleApiError = (error: unknown, fallbackMessage = "An unexpected error occurred"): string => {
  let message = fallbackMessage;

  const extractUsrMsgFromError = (msg: any | undefined): string | undefined => {
    if (!msg) return;
    try {
      const nestedJsonString = msg.match?.(/{.*}/s)?.[0];
      if (nestedJsonString) {
        const parsed = JSON.parse(nestedJsonString);
        return parsed?.usrMsg;
      }
    } catch (e) {
      console.warn("Failed to parse nested JSON from msg:", e);
    }
    return;
  };

  if (axios.isAxiosError(error)) {
    const data = error.response?.data;
    const usrMsg = extractUsrMsgFromError(data);
    message = usrMsg || error.response?.statusText || fallbackMessage;
  } else if (error instanceof Response) {
    message = `Request failed: ${error.status} ${error.statusText}`;
  } else if (error instanceof Error) {
    message = extractUsrMsgFromError(error?.message) || fallbackMessage;
  } else if (typeof error === "string") {
    message = error;
  }

  toast.error(message, {
    position: "bottom-right",
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light"
  });
  return message;
};
